module.exports = __webpack_public_path__ + "static/img/512.7518cc8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/512.png
// module id = 0N6W
// module chunks = 0